import { createTheme, MantineColorsTuple } from "@mantine/core";

const brand: MantineColorsTuple = [
  "#eef2ff", "#dbe3ff", "#b3c1fa", "#869bf7",
  "#637df3", "#4d6cf2", "#3e63f1", "#3052d6",
  "#2849c1", "#1d3da9",
];

export const theme = createTheme({
  primaryColor: "brand",
  colors: { brand },
  fontFamily:
    "-apple-system, BlinkMacSystemFont, Segoe UI, Inter, system-ui, sans-serif",
  defaultRadius: "md",
});
